module.exports = __webpack_public_path__ + "static/img/10.e8e211d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/10.jpg
// module id = OeJB
// module chunks = 36